import { IElementBase } from "core-integration/src/store/elements/types";

export const isPointsStat = (stat: any): boolean => {
  const pointsStats: Array<keyof IElementBase> = [
    "event_points",
    "total_points",
    "points_per_game",
  ];
  return pointsStats.indexOf(stat) > -1;
};

export const integerDivide = (int: number, divisor: number) =>
  Math.trunc(int / divisor);
